export default __webpack_public_path__ + "static/media/ic-user.45a0af68.png";